import { NetworkRequestException } from '../../../exceptions/networkRequestException';
import { defaultErrorToTerm } from '../../../otherBusinessLogic/defaultErrorToTerm';

export function errorToTerm(exception: unknown): string {
  if (exception instanceof NetworkRequestException) {
    switch (exception.status) {
      case 429:
        return 'toggle_maintenance_already_occurring';
    }
  }

  return defaultErrorToTerm(exception) ?? 'toggle_maintenance_unknown_error';
}
